import React from 'react'
import Container from '../../components/Container'
import Divider from '../../components/Divider'
import { StyledFooter, StyledFooterContent, StyledFooterItem } from './styled'

const FooterBar = React.memo(({ children, noDivider }) => {
    return (
        <StyledFooter>
            <Container>
                <StyledFooterContent>
                    {
                        React.Children.map(children, (child, index) => (
                            <React.Fragment key={index}>
                                <StyledFooterItem>{child}</StyledFooterItem>
                                {
                                    index < children.length - 1 && !noDivider &&
                                    <Divider vertical />
                                }
                            </React.Fragment>
                        ))
                    }
                </StyledFooterContent>
            </Container>
        </StyledFooter>
    )
})

FooterBar.defaultProps = {
    noDivider: false
}

export default FooterBar